import { render, staticRenderFns } from "./Saude.vue?vue&type=template&id=efbea302"
import script from "./Saude.vue?vue&type=script&lang=js"
export * from "./Saude.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports